import { useDispatch, useSelector } from "react-redux";
import {
  IonAvatar,
  IonCard,
  IonGrid,
  IonIcon,
  IonItem,
  IonLabel,
  IonNote,
  IonSearchbar,
  IonText,
  isPlatform,
} from "@ionic/react";
import {
  documentTextOutline,
  personOutline,
  calendarOutline,
  bookmarkOutline,
} from "ionicons/icons";
import { DocumentStatusTag } from "../../../components/Document/DocumentStatusTag";
import { setDocumentSearchText } from "../../../store/supervisorHome";
import { selectDocuments } from "../../../store/userShow/selectors/selectDocuments";
export const TodoListSection: React.FC = () => {
  const dispatch = useDispatch();
  const documents = useSelector(selectDocuments);
  return (
    <>
      <h2 className="ion-padding-horizontal">
        <IonText color="primary">Documentos</IonText>
      </h2>
      <h4 className="ion-padding-horizontal">
        <IonText color="primary">Acuerdos ({documents.length})</IonText>
      </h4>
      <IonSearchbar
        style={{ maxWidth: 360 }}
        placeholder="Buscar acuerdo"
        onIonChange={({ detail: { value = "" } }) => dispatch(setDocumentSearchText(value))}
        class="ion-no-padding ion-padding-start ion-padding-bottom"
      ></IonSearchbar>
      <IonGrid>
        {documents.length === 0 && (
          <IonCard>
            <IonItem lines="none">
              <IonLabel>
                <IonText color="medium" style={{ fontWeight: 500 }}>
                  No se han encontrado acuerdos
                </IonText>
              </IonLabel>
            </IonItem>
          </IonCard>
        )}
        {documents.map((document) => (
          <IonCard key={document.id} class="ion-margin-bottom">
            <IonItem routerLink={`/app/rrhh/acuerdos/${document.id}`} lines="none">
              {isPlatform("desktop") && (
                <IonAvatar slot="start">
                  <IonIcon icon={documentTextOutline} size="large" />
                </IonAvatar>
              )}
              <IonLabel>
                <h2 style={{ fontWeight: 500 }} className="ion-text-wrap">
                  {document.title}
                </h2>
                <h4>
                  <IonIcon icon={personOutline}></IonIcon>
                  <IonText class="ion-padding-start">{document.author?.name}</IonText>
                </h4>
                <p>
                  <IonIcon icon={calendarOutline}></IonIcon>
                  <IonText class="ion-padding-start">{document.createdAt}</IonText>

                  <IonIcon icon={bookmarkOutline} class="ion-padding-start" />
                  <IonText class="ion-padding-start">{`${document.category?.name}`}</IonText>
                </p>
              </IonLabel>

              <IonNote slot="end">
                <DocumentStatusTag document={document} />
              </IonNote>
            </IonItem>
          </IonCard>
        ))}
      </IonGrid>
    </>
  );
};
